import {
  UPDATE_TEXT_BLOCKS,
  UPDATE_TEXT_OVERLAY_SHOW,
} from 'actions/textOverlay';

const DEFAULT_STATE = {
  show: false,
  textBlocks: [],
};

const textOverlayReducer = (state = DEFAULT_STATE, action) => {
  switch (action.type) {
    case UPDATE_TEXT_OVERLAY_SHOW:
      return {
        ...state,
        show: action.show,
      };

    case UPDATE_TEXT_BLOCKS:
      return {
        ...state,
        textBlocks: action.textBlocks,
      };
    default:
      return state;
  }
};

export default textOverlayReducer;
